import styled, { CSSObject } from "styled-components";

export const BenefitsImage = styled.div(() => ({
    width: "100%",
    position: "absolute" as CSSObject["position"],
    bottom: "-5px",
    left: 0,
}));

export const CtaContainer = styled.div(({ theme }) => ({
    width: "88%",
    height: "30vw",
    position: "absolute",
    borderRadius: theme.cornerRadius.small,
    bottom: "4vw",
    left: "6%",
    opacity: 0.5,
    zIndex: 1,
}));
